import { makeAutoObservable, toJS } from 'mobx'

import { ActiveTicketBought } from 'shared/api/avia/main-page'
import { SecondsInMilliseconds, TimerDays } from 'shared/hooks/use-timer'

import { startTimerInit } from '../libs'

class NearDirection {
  timer: TimerDays | undefined
  nearTicket: ActiveTicketBought | undefined
  indexTimer: NodeJS.Timeout | undefined

  constructor() {
    makeAutoObservable(this)
  }

  setNearTicket(ticket?: ActiveTicketBought) {
    if (ticket) this.nearTicket = ticket
  }

  getNearTicket() {
    return toJS(this.nearTicket)
  }

  startTimer(totalSeconds?: number) {
    if (!totalSeconds || totalSeconds <= 0) return

    const timer = startTimerInit(totalSeconds)

    this.timer = timer()

    this.indexTimer = setInterval(() => {
      this.timer = timer()
    }, SecondsInMilliseconds)
  }

  getTimer() {
    return toJS(this.timer)
  }

  stopTimer() {
    clearInterval(this.indexTimer)
  }
}

export const nearDirection = new NearDirection()
